import React, { Fragment } from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import isServer from '@cotyorg/ccx-utils/js/helpers/isServer';
import Heading from '@cotyorg/ccx-atoms/Heading';
import CategoryDropdown from '../CategoryDropdown';

const FilterDropdowns = ({
  categories = [],
  toggleFilter,
  closedCategories,
  toggleFilterCategory,
  headingLevel,
  filterByHeadingText = '',
  dropdownClosedIconSrc,
  dropdownOpenIconSrc,
  showProductCount,
}) => (
  <Fragment>
    <Heading level={headingLevel} extraClass="filter__heading">{filterByHeadingText}</Heading>
    <div className="grid-x grid-margin-x align-top">
      {
        categories.map((category) => {
          if (!R.path(['options', 'length'])(category)) {
            return null;
          }

          return (
            <CategoryDropdown
              key={category.name}
              category={category}
              toggleFilter={toggleFilter}
              closedCategories={closedCategories}
              toggleFilterCategory={toggleFilterCategory}
              dropdownClosedIconSrc={dropdownClosedIconSrc}
              dropdownOpenIconSrc={dropdownOpenIconSrc}
              showProductCount={showProductCount}
            />
          );
        })
      }
      { /*
        Only render the submit button on the server as we want to hide it
        when client-side JS loads
      */ }
      { isServer && <input className="cell shrink" type="submit" /> }
    </div>
  </Fragment>
);

FilterDropdowns.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })).isRequired,
  toggleFilter: PropTypes.func.isRequired,
  closedCategories: PropTypes.objectOf(PropTypes.bool),
  toggleFilterCategory: PropTypes.func.isRequired,
  headingLevel: PropTypes.number.isRequired,
  filterByHeadingText: PropTypes.string.isRequired,
  dropdownClosedIconSrc: PropTypes.string.isRequired,
  dropdownOpenIconSrc: PropTypes.string.isRequired,
  showProductCount: PropTypes.bool.isRequired,
};

export default FilterDropdowns;
